import React from "react";

export function TimeTableWizardNav() {
  return (
    <div className="wizard-nav">
      <div className="wizard-steps">
        <button 
          type="button"
          className="wizard-step" 
          data-wizard-type="step"
          style={{borderStyle: "none", flexBasis: "calc(50% - 0.5rem)"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">1</div>
            <div className="wizard-label">
              <div className="wizard-title">Sınıfa Göre Sıralı</div>
            </div>
          </div>
        </button>
        <button 
          type="button"
          className="wizard-step" 
          data-wizard-type="step" 
          style={{borderStyle: "none", flexBasis: "calc(50% - 0.5rem)"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">2</div>
            <div className="wizard-label">
              <div className="wizard-title">Öğretmene Göre Sıralı</div>
            </div>
          </div>
        </button>
        <div className="wizard-step"></div>
        <div className="wizard-step"></div>
      </div>
    </div>          
  );
}